import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import { defineMessages, injectIntl } from "react-intl";
import { LatestActivities, SceneContainer } from "../../components";
import { NAVIGATION_LABELS } from "../../constants/navigation-internationalized-labels";
import { NAVIGATION_ITEM_IDENTIFIERS } from "../../constants/navigation-item-identifier";
import { dashboardPath } from "../../constants/routing-constants";
import { withDashboardStores, WithLoadingData } from "../../hoc";
import { DataAttributes, DataAttributesBuilder } from "../../services/DataAttributesBuilder";
import { NavigationItem } from "../../stores/navStore/navStore";
import { NAVIGATION_PRIORITY } from "../../stores/navStore/navStoreModel";
import Header from "./components/Header";
import SpaceStats from "./components/SpaceStats";
import { HomeProps, InjectedProps } from "./HomeModel";

const homeLabels = defineMessages({
  title: {
    id: "Home.title",
    defaultMessage: "Your dashboard",
  },
});

@inject("activityStore", "navStore", "spaceDetailStore")
@observer
class Home extends Component<HomeProps> {
  get injected() {
    return this.props as InjectedProps;
  }

  componentDidMount() {
    const { formatMessage } = this.props.intl;
    const {
      match: {
        params: { spaceId },
      },
    } = this.props;
    this.injected.navStore.setNavigationPath(
      new NavigationItem(
        NAVIGATION_ITEM_IDENTIFIERS.DASHBOARD,
        dashboardPath(spaceId),
        formatMessage(NAVIGATION_LABELS.dashboard),
        NAVIGATION_PRIORITY.FIRST,
      ),
    );
  }

  componentWillUnmount() {
    this.injected.navStore.removeItem(NAVIGATION_ITEM_IDENTIFIERS.DASHBOARD);
  }

  initializeData = () => {
    return Promise.all([
      this.injected.activityStore.initializeHomeLatestActivities(),
      this.injected.spaceDetailStore.refresh(),
    ]);
  };

  createSceneContainerAttributes = (): DataAttributes => {
    return new DataAttributesBuilder("dashboard").setNameAttribute("dashboard").build();
  };

  render() {
    const {
      intl: { formatMessage },
    } = this.props;
    const {
      activityStore: { userLatestActivities, teamLatestActivities },
      spaceDetailStore: { spaceApiCredentials, spaceStats },
    } = this.injected;

    return (
      <SceneContainer
        title={formatMessage(homeLabels.title)}
        dataAttributes={this.createSceneContainerAttributes().Attributes}
        flex={true}
      >
        <WithLoadingData promise={this.initializeData}>
          <Header spaceApiCredentials={spaceApiCredentials} />
          <SpaceStats spaceStats={spaceStats} />
          <LatestActivities userActivity={userLatestActivities.items} teamActivity={teamLatestActivities.items} />
        </WithLoadingData>
      </SceneContainer>
    );
  }
}

export default withDashboardStores(injectIntl(Home));
